import React from "react";
import "../../css/App.css";
import PathFindingVisualizer from "../PathFindingVisualizer/PathFindingVisualizer";

export default function App() {
    return (
            <div className="App">
                <PathFindingVisualizer></PathFindingVisualizer>
            </div>
        );
}
